module.exports = {
  content: ['./src/**/*.{ts,tsx}'],
  theme: {
    extend: {
      boxShadow: {
        pink: '0 0 20px 0 #DC32AD',
        ['pink-inset']: '0 0 14px 0 #DC32AD inset',
      },
      backgroundImage: {
        'global-background-maintenance': `url('/images/maintenance.png')`,
      },
      colors: {
        neutral: {
          930: '#141414',
          990: '#0c0c0c',
        },
        neon: {
          blue: '#00FBEC',
        },
        akiverse: {
          pink: '#DC32AD',
          teras: '#DEE139',
          akir: '#00FBEC',
          akv: '#BD00FF',
          yellow: '#FCFF54',
        },
        quest: {
          onward: { main: '#3378FF' },
          event: { main: '#DD32AD' },
          premium: { main: '#DDCC32' },
          vip: { main: '#E51414' },
        },
      },
      borderWidth: {
        0.5: '0.5px',
      },
      keyframes: {
        'hint-focused': {
          '0%': {
            transformOrigin: 'top left',
            transform: 'translate(0,0) scale(1)',
          },
          '100%': {
            transformOrigin: 'top left',
            transform: 'translate(-4px,-10px) scale(0.65)',
          },
        },
        'hint-blur': {
          '0%': {
            transformOrigin: 'top left',
            transform: 'translate(-4px,-10px) scale(0.65)',
          },
          '100%': {
            transformOrigin: 'top left',
            transform: 'translate(0,0) scale(1)',
          },
        },
      },
      animation: {
        'form-hint-focus': 'hint-focused 0.2s ease-in-out both',
        'form-hint-blur': 'hint-blur 0.2s ease-in-out both',
      },
    },
  },
  plugins: [require('@tailwindcss/custom-forms')],
}
